import { guage, kosten, durchsatz, störfälle, graphData } from './content.model'

export default class AreaService {

    fetchGuages(machine: string, from: Date, to: Date): Promise<guage[]> {
        return fetch('api/v1/oeedashboard/gauges?machine=' + machine + "&from=" + from.toISOString() + "&to=" + to.toISOString())
            .then(response => response.json())
            .catch(err => { console.log(err); return { result: { performance: NaN, availibility: NaN, quality: NaN } }; })
            .then(d => {
                return [
                    { id: 1, name: "Auslastung (%)", value: Math.round(Number.parseFloat(d.result.performance) * 10000) / 100 },
                    { id: 2, name: "Verfügbarkeit (%)", value: Math.round(Number.parseFloat(d.result.availibility) * 10000) / 100 },
                    { id: 3, name: "Sortierquote (%)", value: Math.round(Number.parseFloat(d.result.quality) * 10000) / 100 }
                ]
            });
    }

    fetchCost(machine: string, from: Date, to: Date): Promise<graphData<kosten>> {
        return fetch('api/v1/oeedashboard/costs?machine=' + machine + "&from=" + from.toISOString() + "&to=" + to.toISOString())
            .then(response => response.json())
            .then(d => d.result?.map(e => { return { time: new Date(e.timeStamp), description: (Math.round(Number.parseFloat(e.value) * 100) / 100) + " at " + new Date(Date.parse(e.timeStamp)).toLocaleTimeString().substring(0, 5), value: e.value } }))
            .catch(err => { console.log(err); return []; })
            .then(d => {
                let obj = new graphData<kosten>();
                obj.data = d;
                obj.name = "Kosten";
                return obj;
            });
    }

    fetchThroughput(machine: string, from: Date, to: Date): Promise<graphData<durchsatz>> {
        return fetch('api/v1/oeedashboard/throughput?machine=' + machine + "&from=" + from.toISOString() + "&to=" + to.toISOString())
            .then(response => response.json())
            .then(d => d.result?.map(e => { return { time: new Date(e.timeStamp), description: (Math.round(Number.parseFloat(e.value) * 100) / 100) + " at " + new Date(Date.parse(e.timeStamp)).toLocaleTimeString().substring(0, 5), value: e.value } }))
            .catch(err => { console.log(err); return []; })
            .then(d => {
                let obj = new graphData<durchsatz>();
                obj.data = d;
                obj.name = "Durchsatz";
                return obj;
            });
    }
    fetchIncidents(): Promise<graphData<störfälle>> {
        //return fetch('api/guage/guages')
        //    .then(response => response.json() as Promise<guage[]>);
        return new Promise((resolve, reject) => {
            let g: störfälle[] = [
                { description: "Druck abgefallen", id: 201, status: "behoben" },
                { description: "Halt X fehler in Folge", id: 382, status: "behoben" },
                { description: "Station 2: Druck", id: 415, status: "in arbeit" }
            ];

            let obj: graphData<störfälle> = new graphData<störfälle>();
            obj.data = g;
            obj.name = "Störfälle";
            resolve(obj);
        });
    }
}